import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { getCurrentCategory } from "util/helper/helper";
import { createVehicleDescription } from "util/vehicle/createVehicleDescription";
import styles from "./NoSearchResultMessage.module.scss";

function NoSearchResultMessage() {
  const router = useRouter();
  const { query } = router;

  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  const { urlInformation } = useSelector((store: RootState) => store.utils);
  const currentCategory = getCurrentCategory(urlInformation, query);
  const vehicleDesc = createVehicleDescription(selectedVehicle, false, false, true);

  if (!currentCategory) return null;

  return (
    <div className={styles.no_search_container}>
      <PAText component="p" fontSize={FONT_SIZE[3]}>
        {`0 ${currentCategory} results ${selectedVehicle ? " for your " : ""}`}
        <PAText fontSize={FONT_SIZE[3]} bold>
          {selectedVehicle ? `${vehicleDesc}` : ""}
          .
        </PAText>
      </PAText>
    </div>
  );
}

export default NoSearchResultMessage;
